import React, { useState } from "react";
import { useLocalStorage } from "@uidotdev/usehooks";
import HelpPopup from "./components/HelpPopup";
import ErrorPopup from "./components/ErrorPopup";
import ExpiredPopup from "./components/ExpiredPopup";

const Login = () => {
    const [popupOpen, setPopupOpen] = useState(false); // Help popup
    const [currentSlide, setCurrentSlide] = useState(0);
    const [name, setName] = useState("");
    const [batchCode, setBatchCode] = useState("");
    const [storedName, setStoredName] = useLocalStorage("name", null);
    const [storedBatchCode, setStoredBatchCode] = useLocalStorage("batchCode", null);
    const [storedLogo, setStoredLogo] = useLocalStorage("logo", null);
    const [submitting, setSubmitting] = useState(false);
    const [errorOpen, setErrorOpen] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [expiredOpen,setExpiredOpen] = useState(false);
    const [expiredMessage, setExpiredMessage] = useState("");

    // Help slides for the popup. Using placeholder images for now
    const slides = [
        {
            src: "img/barcode-img.jpg",
            // src: "https://placehold.co/600x400",
            title: "Batch Code",
            description:
                "This is what a batch code generally looks like. Locate and enter the batch code from your product.",
        },
        {
            src: "img/barcode-img.jpg",
            // src: "https://placehold.co/600x400?text=Where+to+find+it",
            title: "Where to find it",
            description:
                "You can usually find the batch code near the manufacturing or expiry details printed on the pack.",
        },
        {
            src: "img/barcode-img.jpg",
            // src: "https://placehold.co/600x400?text=Example",
            title: "Example",
            description:
                "Example format: DT-ABC12345 or printed as a stamped alphanumeric string on the carton.",
        },
    ];

    const togglePopup = () => {
        setPopupOpen(!popupOpen);
    };

    const toggleError = () => {
        setErrorOpen(!errorOpen);
    };
    const toggleExpired=()=>{
        setExpiredOpen(!expiredOpen);
    }
    const changeSlide = (direction) => {
        let newIndex = currentSlide + direction;
        if (newIndex < 0) newIndex = slides.length - 1;
        if (newIndex >= slides.length) newIndex = 0;
        setCurrentSlide(newIndex);
    };

    const handleSubmit = async () => {
        const trimmedName = name.trim();
        const code = batchCode.trim();
        // if (!trimmedName) {
        //     setErrorMessage("Please enter your name.");
        //     setErrorOpen(true);
        //     return;
        // }
        if (!code) {
            setErrorMessage("Please enter your product batch code.");
            setErrorOpen(true);
            return;
        }
        try {
            setSubmitting(true);
            // Use production base URL
            const base = 'https://knowyourmilk-uat.smartmoo.com/traceability/service-04/dairy-tales/';
            const API_KEY = 'TrAceAbiLITy@^)!';
            const url = `${base}${encodeURIComponent(code)}/brand`;
            const res = await fetch(url, { method: 'GET', headers: { 'x-api-key': API_KEY } });
            const json = await res.json();
            const maybe = json && json.data && json.data.logo && json.data.logo.image;
            if (json?.message ===" FAILED") {
                setExpiredMessage("This product is past its best-use date, so the traceability data isn't available. To still view it, reach out to us at info@moomark.in.")
                setExpiredOpen(true);
            }
            if (json && json.statusCode === 200 && typeof maybe === 'string') {
                setStoredName(trimmedName);
                setStoredBatchCode(code);
                setStoredLogo(json.data.logo.image);

                setTimeout(() => {
                    const target = `${window.location.origin}/home`;
                    console.log(target);
                    window.location.href = target;
                }, 10);
               
            }
             else {
                setErrorMessage('Invalid batch code. Please check and try again.');
                setErrorOpen(true);
            }
        } catch (e) {
            setErrorMessage('Network error validating batch code. Please try again.');
            setErrorOpen(true);
        } finally {
            setSubmitting(false);
        }
    }

    return (
        <div
            className="bg-green-100 flex items-center justify-center min-h-screen bg-cover bg-center"
            style={{ backgroundImage: "url('img/bg-signin.jpg')" }}
        >
            {/* QR Code Section (Only visible on screens ≥1024px) */}
            <div className="qr-container hidden lg:flex justify-center items-center h-screen w-full absolute top-0 left-0">
                <div className="bg-white p-4 rounded-lg shadow-lg text-center">
                    <img src="img/qr-code.png" alt="QR Code" className="w-32 h-32 mx-auto" />
                    <p className="text-lg font-bold text-green-700 mt-2">
                        Scan Me to View on Your Device
                    </p>
                </div>
            </div>

            {/* Content Container (hidden on large screens) */}
            <div className="content-container mx-8 block lg:hidden">
                {/* Header */}
                <div className="text-center mt-4">
                    <h1 className="text-2xl font-bold text-black" style={{ lineHeight: "2.7rem" }}>
                        Let's Unlock Your Products Story!
                    </h1>
                </div>

                {/* Form */}
                <form onSubmit={(e) => e.preventDefault()}>
                    <label className="block text-gray-900 mt-4">Your Name</label>
                    <input
                        type="text"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        className="w-full p-3 border border-gray-800 rounded-md focus:border-green-500 outline-gray-500"
                    />

                    <div className="mt-4 relative">
                        <label className="block text-gray-700">Product Batch Code</label>

                        <div className="relative">
                            <input
                                type="text"
                                value={batchCode}
                                onChange={(e) => setBatchCode(e.target.value)}
                                className="w-full p-3 border border-gray-300 rounded-md focus:border-green-500 outline-none pr-10"
                            />
                            <button
                                type="button"
                                onClick={togglePopup}
                                className="absolute inset-y-0 right-0 flex items-center px-3 text-white rounded-r-md"
                                style={{ backgroundColor: "#4c902b" }}
                            >
                                ?
                            </button>
                        </div>
                    </div>


                    <p className="mt-2 text-sm text-gray-600">
                        Having Trouble?{" "}
                        <button
                            type="button"
                            onClick={togglePopup}
                            className="font-bold"
                            style={{ color: "#4c902b" }}
                        >
                            Get Help
                        </button>
                    </p>

                    {/* Submit Button */}
                    <button
                        type="button"
                        onClick={handleSubmit}
                        disabled={submitting}
                        className="w-full mt-6 text-white py-3 rounded-lg hover:bg-green-700 disabled:opacity-60"
                        style={{ backgroundColor: "#4c902b" }}
                    >
                        {submitting ? 'VALIDATING…' : 'START YOUR STORY'}
                    </button>
                </form>

                {/* Footer */}
                <div className="text-center mt-6 text-sm text-gray-500">
                    <img src="img/moomark-logo.png" alt="mooMark Logo" className="mx-auto w-44" />
                    <p className="mt-2">2020 Copyright moomark.in</p>
                </div>
            </div>

            {/* Help Popup */}
            <HelpPopup isOpen={popupOpen} onClose={togglePopup} slides={slides} />

            {/* Error Popup */}
            <ErrorPopup isOpen={errorOpen} onClose={toggleError} message={errorMessage} />

            {/* Expired Popup */}
            <ExpiredPopup isOpen={expiredOpen} onClose={toggleExpired} message={expiredMessage} />
        </div>
    );
};

export default Login;
